import React, { useEffect, useState, useContext } from 'react';
import { BiRightArrowAlt } from 'react-icons/bi';
import scrollTo from 'gatsby-plugin-smoothscroll';
import { isEmpty } from 'lodash';
import { Section } from './styles/SectionHeadline.styled';
import { Container } from './styles/Container.styled';
import { Row } from './styles/Row.styled';
import { ColumnMdTen } from './styles/Column.styled';
import { DWTCContext } from '../utils/context';
import { getTranslationByKey } from '../helpers/translation-helper';

import {
  StickySidebarColumnTwo,
  StickySidebar,
  Sidebar,
  TimeBlock,
  SectionPagination,
  ULPagination,
  LiPagination,
  BackToTop,
  TimeDistanceWrapper,
} from './styles/FilterTabBlock.styled';
import ExperiencesCardsBlock from './ExperiencesCardsBlock';
import ExperiencesFilterTabBar from './ExperiencesFilterTabBar';

export default function Experiences({ data, dir, id }) {
  const isBrowser = typeof window !== 'undefined';

  const { translations } = useContext(DWTCContext);

  const types = [
    { name: 'restaurant', label: 'Where To Eat' },
    { name: 'hotel', label: 'Where To Stay' },
    { name: 'activity', label: 'What To Do' },
    { name: 'sightseeing', label: 'What To See' },
    { name: 'featured', label: 'Explore Featured' },
  ];
  const [selectedFilter, setSelectedFilter] = useState('Where To Eat');
  const [distanceValue, setDistanceValue] = useState(15);
  const [isNavOpen, setIsNavOpen] = useState(false);

  const [experiencesByDistance, setExperiencesByDistance] = useState({
    less: data.experiences
      .filter(({ content }) => content.category === selectedFilter)
      .filter((value) => +value.content.distance === 15),
    between: data.experiences
      .filter(({ content }) => content.category === selectedFilter)
      .filter((value) => +value.content.distance === 20),
    greater: data.experiences
      .filter(({ content }) => content.category === selectedFilter)
      .filter((value) => value.content.distance === '> 20'),
  });

  useEffect(() => {
    (() => {
      let newFilteredData = [];
      if (selectedFilter === 'Explore Featured') {
        newFilteredData = data.experiences.filter(
          ({ content }) =>
            content.type === types.find((item) => item.label === selectedFilter).name,
        );
      } else {
        newFilteredData = data.experiences.filter(
          ({ content }) =>
            content.category === types.find((item) => item.label === selectedFilter).name,
        );
      }
      setExperiencesByDistance({
        less: newFilteredData.filter((value) => +value.content.distance === 15),
        between: newFilteredData.filter((value) => +value.content.distance === 20),
        greater: newFilteredData.filter((value) => value.content.distance === '> 20'),
      });
    })();
  }, [selectedFilter]);

  const scrollLess = () => {
    const lessEl = document.getElementById('less');
    if (lessEl) {
      if (lessEl.getBoundingClientRect().top > -800 && lessEl.getBoundingClientRect().top < 50) {
        setDistanceValue(15);
      }
    }
  };
  const scrollBetween = () => {
    const betweenEl = document.getElementById('between');
    if (betweenEl) {
      if (
        betweenEl.getBoundingClientRect().top > -800 &&
        betweenEl.getBoundingClientRect().top < 50
      ) {
        setDistanceValue(20);
      }
    }
  };

  const scrollGreater = () => {
    const greaterEl = document.getElementById('greater');
    if (greaterEl) {
      if (
        greaterEl.getBoundingClientRect().top > -800 &&
        greaterEl.getBoundingClientRect().top < 50
      ) {
        setDistanceValue('> 20');
      }
    }
  };

  useEffect(() => {
    if (isBrowser) {
      (() => {
        window.addEventListener('scroll', () => {
          setIsNavOpen(document.getElementById('topbar-header').classList.contains('isSticky'));
          scrollLess();
          scrollBetween();
          scrollGreater();
        });
      })();
    }
    return () => {
      if (isBrowser) {
        window.removeEventListener('scroll', () => {
          scrollLess();
          scrollBetween();
          scrollGreater();
        });
      }
    };
  });

  const minuteLabel = dir === 'rtl' ? 'دقيقة' : 'minutes';
  return (
    <>
      <ExperiencesFilterTabBar
        id={`${id}_filter-tab-bar`}
        data={data}
        selectedFilter={selectedFilter}
        setSelectedFilter={setSelectedFilter}
        setDistanceValue={setDistanceValue}
        dir={dir}
      />
      <Section id={id}>
        <Container>
          <Row>
            <StickySidebarColumnTwo className="sticky_top">
              <StickySidebar>
                <Sidebar>
                  <TimeDistanceWrapper className="experience_sticky">
                    <TimeBlock dir={dir}>
                      <time dir={dir}>{distanceValue}</time>
                      <span dir={dir}>{minuteLabel}</span>
                    </TimeBlock>
                    <SectionPagination>
                      <ULPagination>
                        <LiPagination>
                          <button
                            type="button"
                            onClick={() => {
                              setTimeout(() => setDistanceValue(15), 400);
                              scrollTo('#less');
                            }}
                            dir={dir}
                          >
                            15
                          </button>
                        </LiPagination>
                        <LiPagination>
                          <button
                            type="button"
                            onClick={() => {
                              setTimeout(() => setDistanceValue(20), 400);
                              scrollTo('#between');
                            }}
                            dir={dir}
                          >
                            20
                          </button>
                        </LiPagination>
                        <LiPagination>
                          <button
                            type="button"
                            className="arrow_btn"
                            onClick={() => {
                              setTimeout(() => setDistanceValue('> 20'), 400);
                              scrollTo('#greater');
                            }}
                            dir={dir}
                          >
                            <BiRightArrowAlt className="arrow" />
                            20
                          </button>
                        </LiPagination>
                      </ULPagination>
                    </SectionPagination>
                  </TimeDistanceWrapper>
                  <BackToTop dir={dir}>
                    <a href="#0" role="button" onClick={() => scrollTo('#backtotop')}>
                      {getTranslationByKey(translations, 'Back to top')}
                    </a>
                    <span>↑</span>
                  </BackToTop>
                </Sidebar>
              </StickySidebar>
            </StickySidebarColumnTwo>
            <ColumnMdTen isNavOpen={isNavOpen} id="backtotop" className="experience_section">
              {isEmpty(experiencesByDistance.less) || (
                <div id="less">
                  <ExperiencesCardsBlock
                    data={experiencesByDistance.less}
                    exporeFeatured={selectedFilter === 'Explore Featured'}
                    dir={dir}
                  />
                </div>
              )}
              {isEmpty(experiencesByDistance.between) || (
                <div id="between">
                  <ExperiencesCardsBlock
                    data={experiencesByDistance.between}
                    exporeFeatured={selectedFilter === 'Explore Featured'}
                    dir={dir}
                  />
                </div>
              )}
              {isEmpty(experiencesByDistance.greater) || (
                <div id="greater">
                  <ExperiencesCardsBlock
                    data={experiencesByDistance.greater}
                    exporeFeatured={selectedFilter === 'Explore Featured'}
                    dir={dir}
                  />
                </div>
              )}
            </ColumnMdTen>
          </Row>
        </Container>
      </Section>
    </>
  );
}
